import React from "react"
import { Card, CardBody, Row, Col } from "reactstrap"
import PropTypes from "prop-types"

const LocationCarSummaryCard = ({ cars }) => {
    // Safe check if cars object is null
    const stats = cars || {
        parked_this_week: 0,
        parked_this_month: 0,
        parked_this_year: 0
    }

    return (
        <Card
            style={{
                backgroundColor: "#3C3C3C",
                borderRadius: "15px",
                border: "none",
                height: "100%",
                position: "relative"
            }}
        >
            <CardBody>
                {/* Edit Icon top right */}
                <div className="d-flex justify-content-between align-items-center">
                    <h5 style={{ color: "#FFCA5C", fontWeight: "bold" }}>Ticket Summary</h5>
                </div>
                {/* <div className="position-absolute" style={{ top: "20px", right: "20px" }}>
                    <i className="bx bx-edit" style={{ color: "#fff", cursor: "pointer", fontSize: "18px" }}></i>
                </div> */}

                <Row className="align-items-center h-100">
                    {/* This Week */}
                    <Col xs={4} className="text-center">
                        {/* <h3 style={{ color: "#7BB64E", fontWeight: "bold", marginBottom: "5px" }}>
                            0
                        </h3> */}
                        <h3 style={{ color: "#FFCA5C", fontWeight: "bold", marginBottom: "5px" }}>
                            {stats.parked_this_week}
                        </h3>
                        <small className="text-muted">This Week</small>
                    </Col>

                    {/* This Month */}
                    <Col xs={4} className="text-center">
                        {/* <h3 style={{ color: "#FF5858", fontWeight: "bold", marginBottom: "5px" }}>
                            0
                        </h3> */}
                        <h3 style={{ color: "#FFCA5C", fontWeight: "bold", marginBottom: "5px" }}>
                            {stats.parked_this_month}
                        </h3>
                        <small className="text-muted">This Month</small>
                    </Col>

                    {/* This Year */}
                    <Col xs={4} className="text-center">
                        {/* <h3 style={{ color: "#7BB64E", fontWeight: "bold", marginBottom: "5px" }}>
                            0
                        </h3> */}
                        {/* below was h5 before */}
                        <h3 style={{ color: "#FFCA5C", fontWeight: "bold", marginBottom: "5px" }}>
                            {stats.parked_this_year}
                        </h3>
                        <small className="text-muted">This Year</small>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    )
}

LocationCarSummaryCard.propTypes = {
    cars: PropTypes.object
}

export default LocationCarSummaryCard